import {loadUTMParams} from "../../utils/Referrer";

export const merchantBuiltinFunctions: Record<string, Function> = {};

// These will also be overwritten by the settings from the SDK initOptions
export const merchantBuiltinVariables: Record<string, any> = {
    "utm": loadUTMParams(),
};
